import { config } from 'config';
import httpClient from '@/resources/http-client.js';
import { flyweight } from 'commons/util/interfaces';
import { REST } from 'commons/rest/rest.js';

/**
 * auth.{env} endpoint
 *
 * Deliberately keeps cookie auth (withCredentials, no Bearer interceptor): the token-lifecycle
 * endpoints here — notably /user_token/cookie_refresh — authenticate with the refresh cookie, not
 * the access token, so they must forward cookies. This is the documented exception to the console's
 * cookies→Bearer migration (CM-1682); the data-plane clients (iam/v2/v4) send Bearer and drop cookies.
 */
function AuthAPI() {
    REST.call(this, httpClient, config.auth_url);

    this.api.interceptors.response.use((response) => response.data.result || response.data);
}

AuthAPI.prototype = Object.create(REST.prototype);

const authAPI = flyweight(AuthAPI);

export const getAuthAPI = () => authAPI.register();

const routes = {
    refresh_user_token: () => '/user_token/cookie_refresh',
};

export const refreshUserToken = () => getAuthAPI().get(routes.refresh_user_token());

export const deleteUserToken = () => getAuthAPI().delete(routes.refresh_user_token());
